import { dispatcher, api } from '@unicus/react-ui-kit';

export const REPORT = 'REPORT';
export const REPORT_ACCOUNT_RECEIVABLE = 'REPORT_ACCOUNT_RECEIVABLE';
export const REPORT_ACCOUNT_RECEIVABLE_FINISHED =
  'REPORT_ACCOUNT_RECEIVABLE_FINISHED';

export const getAccountsReceivables = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'reports',
    actionType: REPORT_ACCOUNT_RECEIVABLE,
    effect: async () => api.fetch('reports/accounts-receivables', params)
  });
};

export const getAccountsPayable = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'reports',
    actionType: REPORT_ACCOUNT_RECEIVABLE,
    effect: async () => api.fetch('reports/accounts-payable', params)
  });
};
